<script>
    import { createEventDispatcher } from "svelte";
    const dispatch = createEventDispatcher();

    export let nuevo    = false    
    export let guardar  = false
    export let eliminar = false

    const _handleClickEvent = (OPCION) => {
        dispatch("click",{opcion : OPCION})
    }

</script>

<div class="d-flex direction-row justify-content-end position-relative">
    {#if nuevo}
        <div
            class="circular d-flex justify-content-center align-items-center"
            style="background-color:#2980b9"
            on:click={() => null}
            title={"Nuevo"}
             on:click={() =>_handleClickEvent("CREATE")}
        >
            <ion-icon name="add-outline" />
        </div>
    {/if}
    {#if guardar}
        <div
            class="circular d-flex justify-content-center align-items-center"
            style="background-color:#27ae60"
            on:click={() => null}
            title={"Guardar"}
             on:click={() =>_handleClickEvent("UPDATE")}
        >
            <ion-icon name="save-sharp" />
        </div>
    {/if}
    {#if eliminar}
        <div
            class="circular d-flex justify-content-center align-items-center"
            style="background-color:tomato"
            on:click={() => null}
            title={"Eliminar"}
             on:click={() =>_handleClickEvent("DELETE")}
        >
            <ion-icon name="trash-outline" />
        </div>
    {/if}
</div>

<style>
    .circular {
        height: 30px;
        width: 30px;
        border-radius: 50%;
        background-color: #2c3e50;
        color: #fff;
        cursor: pointer;
        transition: all 250ms;
        margin: 0 5px;
    }

    .circular:hover {
        transform: scale(1.2);
    }
</style>
